module.exports = __webpack_public_path__ + "img/envelope.d2fb8834.svg";